import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';

const CustomLabelTextTable: React.FC<{
  rows: ({ label: string; text: React.ReactNode; startIcon?: React.ReactNode } | null)[];
  excludeNullRows?: boolean;
  cellPadding?: number;
}> = ({ rows, excludeNullRows, cellPadding }) => {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          {rows
            .filter((r) => excludeNullRows !== true || r?.text != null)
            .map((r, index) => {
              if (r == null) return null;
              return (
                <TableRow key={index}>
                  {r.startIcon != null && (
                    <TableCell sx={{ padding: cellPadding }}>
                      <Box display="flex">{r.startIcon}</Box>
                    </TableCell>
                  )}
                  <TableCell
                    colSpan={r.startIcon == null ? 2 : 1}
                    sx={{ whiteSpace: 'nowrap', padding: cellPadding }}
                  >
                    {r.label}
                  </TableCell>
                  <TableCell width="100%" sx={{ padding: cellPadding, wordBreak: 'break-word' }}>
                    {r.text}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomLabelTextTable;
